// TODO: change values when I get the queries
export const dataQueries = [
  {text: 'Date Range for Sturgeon Season', value: 1},
  {text: 'Date Range for Fish Community Season', value: 2},
  {text: 'Null Distance for Gears TN, TL, TTL, OT, POT', value: 3},
  {text: 'Acceptable Distance for Gear OT', value: 4},
  {text: 'Acceptable Distance for Gear POT', value: 5},
  {text: 'Species SNSN in Gear TN', value: 6},
  {text: 'Species SNSG in Gear MF', value: 7},
  {text: 'Temp > 12.7 for Gear GN', value: 8},
  {text: 'Minnows, Chubs, Shiners > 150', value: 9},
];

export const rolesList = {
  1: 'ADMINISTRATOR',
  2: 'OFFICE ADMIN',
  3: 'OFFICE USER',
  4: 'READONLY',
};

export const fieldOfficeList = {
  1: 'CF - Columbia Fishery Resource Office',
  2: 'MO - Missouri Department of Conservation',
  3: 'NE - Nebraska Game and Parks Commission',
  4: 'SD - Yankton FWMAO',
  5: 'GP - Great plains FWMAO',
  6: 'MR - Missouri River FWMAO',
  7: 'MT - Montana Fish Wildlife and Parks',
  8: 'IA - Iowa Department of Natural Resources',
  9: 'KC - USACE Kansas City District',
  10: 'MI - Missouri Department of Conservation Missisippi River',
  11: 'ALL',
};

export const projectCodeList = {
  1: '1 - Pallid Sturgeon Population Assessment',
  2: '2 - Habitat Assessment Program',
  3: '3 - Chute Study - Mitigation Project',
  4: '4 - Spring Rise Evaluation',
  5: '6 - Focused Research',
  6: '5 - Dalbey Bottoms',
};

export const NoRoleAccessMessage = ({ className }) => (
  <small className={`has-text-weight-light ${className}`}><center>You do not have role access to this section/page. Please reach out to Admin if you need access.</center></small>
);